<p-dialog
    [visible]="visible"
    (visibleChange)="visibleChange.emit($event)"
    (onShow)="onDialogShow()"
    header="Browse"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '70vw', maxWidth: '960px', minWidth: '620px' }"
    [contentStyle]="{ maxHeight: '68vh', overflow: 'hidden' }"
    [breakpoints]="{ '1200px': '85vw', '900px': '95vw', '640px': '100vw' }"
    appendTo="body"
>
    <div class="item-browse-modal">
        <div class="browse-search-bar mb-3">
            <p-iconfield class="w-full">
                <p-inputicon styleClass="pi pi-search" />
                <input
                    #itemSearchInput
                    pInputText
                    type="text"
                    [(ngModel)]="searchText"
                    (ngModelChange)="onSearchTextChanged($event)"
                    placeholder="Search by item number or description"
                    class="w-full browse-search-input"
                    (keydown.enter)="onEnterKey()"
                />
            </p-iconfield>
            <div class="browse-search-meta mt-2 flex items-center justify-between gap-2">
                <span class="browse-search-hint" [class.is-loading]="isLoading">{{ searchHint }}</span>
                <span *ngIf="warehouseCode" class="browse-warehouse-badge">WH {{ warehouseCode }}</span>
            </div>
        </div>

        <div class="browse-grid border-round overflow-hidden surface-border" [class.is-loading]="isLoading">
            <p-table
                [value]="searchResults"
                dataKey="itemNumber"
                selectionMode="single"
                [(selection)]="selectedRow"
                (selectionChange)="onRowClick($event)"
                [scrollable]="true"
                [scrollHeight]="'52vh'"
                [style]="{ height: '100%' }"
                class="p-datatable-sm browse-results-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="col-item-no">Itmno</th>
                        <th class="col-description">Description 2</th>
                        <th class="col-inhalt">Inhalt</th>
                        <th class="col-stk">Stk</th>
                        <th *ngIf="showStockColumn" class="col-stock">{{ stockColumnLabel }}</th>
                        <th *ngIf="isDiv300" class="col-price">FR1</th>
                        <th *ngIf="isDiv300" class="col-price">FR2</th>
                        <th *ngIf="isDiv300" class="col-price">FR3</th>
                        <th *ngIf="isDiv400" class="col-price">NL1</th>
                        <th *ngIf="isDiv400" class="col-price">NL2</th>
                        <th *ngIf="isDiv400" class="col-price">NL3</th>
                        <th *ngIf="showPriceLists" class="col-price">PL1</th>
                        <th *ngIf="showPriceLists" class="col-price">PL2</th>
                        <th *ngIf="showPriceLists" class="col-price">PL3</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr
                        [pSelectableRow]="rowData"
                        [ngClass]="{ 'selected-row': selectedRow === rowData }"
                        (dblclick)="onRowDoubleClick(rowData)"
                    >
                        <td class="col-item-no">{{ rowData.itemNumber || rowData.itmno }}</td>
                        <td class="col-description">{{ rowData.description || rowData.description2 }}</td>
                        <td class="col-inhalt">{{ rowData.inhalt }}</td>
                        <td class="col-stk">{{ rowData.stk }}</td>
                        <td *ngIf="showStockColumn" class="col-stock">{{ rowData.stockQty }}</td>
                        <td *ngIf="isDiv300" class="col-price">{{ rowData.fr1 }}</td>
                        <td *ngIf="isDiv300" class="col-price">{{ rowData.fr2 }}</td>
                        <td *ngIf="isDiv300" class="col-price">{{ rowData.fr3 }}</td>
                        <td *ngIf="isDiv400" class="col-price">{{ rowData.nl1 }}</td>
                        <td *ngIf="isDiv400" class="col-price">{{ rowData.nl2 }}</td>
                        <td *ngIf="isDiv400" class="col-price">{{ rowData.nl3 }}</td>
                        <td *ngIf="showPriceLists" class="col-price">{{ rowData.pl1Price }}</td>
                        <td *ngIf="showPriceLists" class="col-price">{{ rowData.pl2Price }}</td>
                        <td *ngIf="showPriceLists" class="col-price">{{ rowData.pl3Price }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="headerColspan" class="browse-empty-state">
                            <i class="pi pi-inbox browse-empty-icon"></i>
                            <span>{{ emptyStateMessage }}</span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer flex justify-end gap-2 mt-4">
            <button pButton label="Cancel" icon="pi pi-times" severity="secondary" type="button" (click)="onClose()"></button>
            <button
                pButton
                label="Select"
                icon="pi pi-check"
                type="button"
                [disabled]="!selectedRow || isLoading"
                (click)="onSelect()"
            ></button>
        </div>
    </ng-template>
</p-dialog>
